import React from 'react';
import { Redirect } from 'react-router-dom';
import { AuthenticatedWrapper } from '@blocs.auth';
import { useArtistContext } from '@consumer-talent.components/core/ArtistContext';
import Page from '@consumer-talent.components/core/Page';

export const ProfileRedirect = () => {
  const { profileId } = useArtistContext();
  return <Redirect to={`/profile/${profileId}`} />;
};

const AuthenticatedProfileRedirect = () => (
  <AuthenticatedWrapper>
    <Page>
      <ProfileRedirect />
    </Page>
  </AuthenticatedWrapper>
);

export default AuthenticatedProfileRedirect;
